import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { MasterItemsModels, UnitsOfMeasureModels, InventoryItemsModels } from './MasterItemsModels';
import type { APIResponse } from '../../Shared/shared';

export const getNewItemBarcode = createAsyncThunk(
  'MasterItemsINV/getNewItemBarcode',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<number>>('Inv/GetNewItemBarcode');

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddMasterItemsINV = createAsyncThunk(
  'MasterItemsINV/AddMasterItems',
  async (item: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await ntxAPI.post('Inv/AddMasterItems', item);
      dispatch(GetMasterItemsList());
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdatMasterItems = createAsyncThunk(
  'MasterItemsINV/UpdatMasterItems',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Inv/UpdatMasterItems', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetMasterItemsList = createAsyncThunk(
  'MasterItemsINV/GetMasterItemsList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('Inv/GetMasterItemsList');
      if (data.succeeded === true) {
        return data.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetMasterItemsById = createAsyncThunk(
  'MasterItemsINV/GetMasterItemsById',
  async (ItemId: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`Inv/GetMasterItemsById?Id=${ItemId}`);
      if (data.succeeded === true) {
        return data.data;
      } else {
        return [];
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// جلب الأصناف حسب المخزن
export const GetMasterItemsListByInventoryId = createAsyncThunk(
  'MasterItemsINV/GetMasterItemsListByInventoryId',
  async (InventoryId: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`Inv/GetMasterItemsListByInventoryId?InventoryId=${InventoryId}`);

      if (data.succeeded) {
        return data.data;
      } else {
        return [];
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
// جلب المخازن حسب الصنف
export const getInventoriesListByItemId = createAsyncThunk(
  'MasterItemsINV/getInventoriesListByItemId',
  async (ItemId: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`Inv/GetInventoriesListByItemId?ItemId=${ItemId}`);

      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue('data.message');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// مع الكمياااااااات - جلب الأصناف مع الوحدات حسب المخزن
export const getOnhandInventoryItemsByInventoryId = createAsyncThunk(
  'MasterItemsINV/getOnhandInventoryItemsByInventoryId',
  async ({ InventoryId, SubInventoryId }: { InventoryId: string; SubInventoryId?: string }, { rejectWithValue }) => {
    try {
      const url = SubInventoryId
        ? `Inv/GetOnhandInventoryItemsByInventoryId?InventoryId=${InventoryId}&SubInventoryId=${SubInventoryId}`
        : `Inv/GetOnhandInventoryItemsByInventoryId?InventoryId=${InventoryId}`;
      const { data } = await ntxAPI.get<APIResponse<InventoryItemsModels[]>>(url);

      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// جلب الأصناف مع الوحدات حسب المخزن - بدون كميات ومع رقم التشغيل لكل صمف
export const getInventoryItemsByInventoryId = createAsyncThunk(
  'MasterItemsINV/getInventoryItemsByInventoryId',
  async (
    { InventoryId, SubInventoryId, Date }: { InventoryId: string; SubInventoryId?: string; Date?: string },
    { rejectWithValue }
  ) => {
    try {
      let url = `Inv/GetInventoryItemsByInventoryId?InventoryId=${InventoryId}`;
      if (SubInventoryId) url += `&SubInventoryId=${SubInventoryId}`;
      if (Date) url += `&Date=${Date}`;
      const { data } = await ntxAPI.get<APIResponse<InventoryItemsModels[]>>(url);

      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// جلب كل الأصناف مع الوحدات
export const getInventoryItems = createAsyncThunk(
  'MasterItemsINV/getInventoryItems',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<InventoryItemsModels[]>>(`Inv/GetInventoryItems`);

      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

///___________________________________________________________
// جلب الأصناف البديلة على حسب الصنف
export const getItemAlternativeByItemId = createAsyncThunk(
  'MasterItemsINV/getItemAlternativeByItemId',
  async (ItemId: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`Inv/GetItemAlternativeByItemId?ItemId=${ItemId}`);

      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue('data.message');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// اضافة وتعديل الأصناف البديـــــــلة
export const AddUpdateItemAlternative = createAsyncThunk(
  'MasterItemsINV/AddUpdateItemAlternative',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Inv/AddUpdateItemAlternative', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// جلب المورديـ، على حسب الصنف
export const getSuppliersByItemId = createAsyncThunk(
  'MasterItemsINV/getSuppliersByItemId',
  async (ItemId: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`Inv/GetSuppliersByItemId?ItemId=${ItemId}`);

      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue('data.message');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// جلب الأصناف الغيـر المخونية
export const getNonInventoryItems = createAsyncThunk(
  'MasterItemsINV/getNonInventoryItems',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`Inv/GetNonInventoryItems`);

      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue('data.message');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetInventoryItemsByOperatingUnitId = createAsyncThunk(
  'MasterItemsINV/GetInventoryItemsByOperatingUnitId',
  async (operatingUnitId: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`Inv/GetInventoryItemsByOperatingUnitId?OperatingUnitId=${operatingUnitId}`);

      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue('data.message');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  MasterItemsList: MasterItemsModels[];
  MasterItemsById: MasterItemsModels;
  MasterItemsListByInventoryId: MasterItemsModels[];
  UnitsOfMeasureList: UnitsOfMeasureModels[];
  InventoriesListByItemId: [];
  InventoryItems: InventoryItemsModels[]; //
  InventoryItemsTo: InventoryItemsModels[]; // مستخدم في أمر التحويل فقط للمقارنة بين أصناف مخزنين
  //
  loadingInventoriesByItemId: boolean;

  loading: boolean;
  error: any | null;
  //
  AlternativeListByItemId: any[];
  AlternativeLoading: boolean;
  AlternativeError: any | null;
  //
  SuppliersByItemId: any[];
  SuppliersLoading: boolean;
  SuppliersError: any | null;
  //
  NonInventoryItemsList: any[];
  NonInventoryItemsLoading: boolean;
  NonInventoryItemsError: any | null;
  //
  InventoryItemsByOperatingUnitId: any[]; // جلب جميع المخاون مع اصنافه حسب وحدة التشغيـل
  InventoryItemsByOperatingUnitIdLoading: boolean;
  InventoryItemsByOperatingUnitIdError: any | null;
} = {
  MasterItemsList: [],
  MasterItemsById: {} as MasterItemsModels,
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  MasterItemsListByInventoryId: [],
  UnitsOfMeasureList: [],
  InventoryItems: [],
  InventoryItemsTo: [], // مستخدم في أمر التحويل فقط للمقارنة بين أصناف مخزنين
  InventoriesListByItemId: [],
  loading: false,
  error: null,
  loadingInventoriesByItemId: false,
  //
  AlternativeListByItemId: [],
  AlternativeError: null,
  AlternativeLoading: false,
  //
  SuppliersByItemId: [],
  SuppliersError: null,
  SuppliersLoading: false,
  //
  NonInventoryItemsList: [],
  NonInventoryItemsLoading: false,
  NonInventoryItemsError: null,
  //
  InventoryItemsByOperatingUnitId: [],
  InventoryItemsByOperatingUnitIdLoading: false,
  InventoryItemsByOperatingUnitIdError: null
};

const MasterItemsSlice = createSlice({
  name: 'MasterItemsINV',
  initialState,
  reducers: {
    cleanUpMasterItemsListByInventoryId: state => {
      state.MasterItemsListByInventoryId = [];
    },
    cleanUpMasterItemsById: state => {
      state.MasterItemsById = {} as MasterItemsModels;
    },
    cleanUpInventoryItems: state => {
      state.InventoryItems = [];
    }
  },
  extraReducers(builder) {
    builder

      //________________________________________________________________
      .addCase(GetMasterItemsList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(GetMasterItemsList.fulfilled, (state, action: PayloadAction<MasterItemsModels[]>) => {
        state.loading = false;
        state.MasterItemsList = action.payload;
      })
      .addCase(GetMasterItemsList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //________________________________________________________________
      .addCase(GetMasterItemsById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(GetMasterItemsById.fulfilled, (state, action: PayloadAction<MasterItemsModels>) => {
        state.loading = false;
        state.MasterItemsById = action.payload;
      })
      .addCase(GetMasterItemsById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //________________________________________________________________
      .addCase(GetMasterItemsListByInventoryId.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(GetMasterItemsListByInventoryId.fulfilled, (state, action: PayloadAction<MasterItemsModels[]>) => {
        state.loading = false;
        if (action.payload === null) {
          state.MasterItemsListByInventoryId = [];
        } else {
          state.MasterItemsListByInventoryId = action.payload;
        }
      })
      .addCase(GetMasterItemsListByInventoryId.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //________________________________________________________________
      .addCase(getInventoriesListByItemId.pending, (state, action) => {
        state.loadingInventoriesByItemId = true;
        state.error = null;
      })
      .addCase(getInventoriesListByItemId.fulfilled, (state, action: PayloadAction<any>) => {
        state.loadingInventoriesByItemId = false;
        state.InventoriesListByItemId = action.payload;
      })
      .addCase(getInventoriesListByItemId.rejected, (state, action: PayloadAction<any>) => {
        state.loadingInventoriesByItemId = false;
        state.error = action.payload;
      })
      //________________________________________________________________
      .addCase(getInventoryItemsByInventoryId.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getInventoryItemsByInventoryId.fulfilled, (state, action: PayloadAction<InventoryItemsModels[]>) => {
        state.loading = false;
        state.InventoryItems = action.payload;
      })
      .addCase(getInventoryItemsByInventoryId.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //________________________________________________________________
      //________________________________________________________________
      .addCase(getOnhandInventoryItemsByInventoryId.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getOnhandInventoryItemsByInventoryId.fulfilled,
        (state, action: PayloadAction<InventoryItemsModels[]>) => {
          state.loading = false;
          state.InventoryItems = action.payload;
        }
      )
      .addCase(getOnhandInventoryItemsByInventoryId.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //________________________________________________________________
      //________________________________________________________________

      //________________________________________________________________
      //________________________________________________________________
      .addCase(getInventoryItems.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getInventoryItems.fulfilled, (state, action: PayloadAction<InventoryItemsModels[]>) => {
        state.loading = false;
        state.InventoryItems = action.payload;
      })
      .addCase(getInventoryItems.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //________________________________________________________________
      .addCase(getItemAlternativeByItemId.pending, (state, action) => {
        state.AlternativeLoading = true;
        state.AlternativeError = null;
      })
      .addCase(getItemAlternativeByItemId.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.AlternativeLoading = false;
        state.AlternativeListByItemId = action.payload;
      })
      .addCase(getItemAlternativeByItemId.rejected, (state, action: PayloadAction<any>) => {
        state.AlternativeLoading = false;
        state.AlternativeError = action.payload;
      })

      //________________________________________________________________
      .addCase(getSuppliersByItemId.pending, (state, action) => {
        state.SuppliersLoading = true;
        state.SuppliersError = null;
      })
      .addCase(getSuppliersByItemId.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.SuppliersLoading = false;
        state.SuppliersByItemId = action.payload;
      })
      .addCase(getSuppliersByItemId.rejected, (state, action: PayloadAction<any>) => {
        state.SuppliersLoading = false;
        state.SuppliersError = action.payload;
      })
      //________________________________________________________________

      .addCase(getNonInventoryItems.pending, (state, action) => {
        state.NonInventoryItemsLoading = true;
        state.NonInventoryItemsError = null;
      })
      .addCase(getNonInventoryItems.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.NonInventoryItemsLoading = false;
        state.NonInventoryItemsList = action.payload;
      })
      .addCase(getNonInventoryItems.rejected, (state, action: PayloadAction<any>) => {
        state.NonInventoryItemsLoading = false;
        state.NonInventoryItemsError = action.payload;
      })
      //________________________________________________________________
      //________________________________________________________________

      .addCase(GetInventoryItemsByOperatingUnitId.pending, (state, action) => {
        state.InventoryItemsByOperatingUnitIdLoading = true;
        state.InventoryItemsByOperatingUnitIdError = null;
      })
      .addCase(GetInventoryItemsByOperatingUnitId.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.InventoryItemsByOperatingUnitIdLoading = false;
        state.InventoryItemsByOperatingUnitId = action.payload;
      })
      .addCase(GetInventoryItemsByOperatingUnitId.rejected, (state, action: PayloadAction<any>) => {
        state.InventoryItemsByOperatingUnitIdLoading = false;
        state.InventoryItemsByOperatingUnitIdError = action.payload;
      });
    //________________________________________________________________
  }
});

export const { cleanUpMasterItemsListByInventoryId, cleanUpMasterItemsById, cleanUpInventoryItems } =
  MasterItemsSlice.actions;
export default MasterItemsSlice.reducer;
